import { HttpLink } from "@apollo/client";
import axios from "axios";
import { buildAxiosFetch } from "./axios-fetch";
export const httpLink = (uri) => new HttpLink({
    uri,
    fetch: buildAxiosFetch(axios),
    includeExtensions: true,
});
//# sourceMappingURL=http-link.js.map